"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_StructureDefinition = exports.StructureDefinitionDerivationKind = exports.StructureDefinitionKindKind = exports.StructureDefinitionFhirVersionKind = exports.StructureDefinitionStatusKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_ContactDetail_1 = require("./RTTI_ContactDetail");
var RTTI_markdown_1 = require("../Scalar/RTTI_markdown");
var RTTI_UsageContext_1 = require("./RTTI_UsageContext");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Coding_1 = require("./RTTI_Coding");
var RTTI_StructureDefinition_Mapping_1 = require("./RTTI_StructureDefinition_Mapping");
var RTTI_StructureDefinition_Context_1 = require("./RTTI_StructureDefinition_Context");
var RTTI_canonical_1 = require("../Scalar/RTTI_canonical");
var RTTI_StructureDefinition_Snapshot_1 = require("./RTTI_StructureDefinition_Snapshot");
var RTTI_StructureDefinition_Differential_1 = require("./RTTI_StructureDefinition_Differential");
var StructureDefinitionStatusKind;
(function (StructureDefinitionStatusKind) {
    StructureDefinitionStatusKind["_draft"] = "draft";
    StructureDefinitionStatusKind["_active"] = "active";
    StructureDefinitionStatusKind["_retired"] = "retired";
    StructureDefinitionStatusKind["_unknown"] = "unknown";
})(StructureDefinitionStatusKind = exports.StructureDefinitionStatusKind || (exports.StructureDefinitionStatusKind = {}));
var StructureDefinitionFhirVersionKind;
(function (StructureDefinitionFhirVersionKind) {
    StructureDefinitionFhirVersionKind["_001"] = "0.01";
    StructureDefinitionFhirVersionKind["_005"] = "0.05";
    StructureDefinitionFhirVersionKind["_006"] = "0.06";
    StructureDefinitionFhirVersionKind["_011"] = "0.11";
    StructureDefinitionFhirVersionKind["_0080"] = "0.0.80";
    StructureDefinitionFhirVersionKind["_0081"] = "0.0.81";
    StructureDefinitionFhirVersionKind["_0082"] = "0.0.82";
    StructureDefinitionFhirVersionKind["_040"] = "0.4.0";
    StructureDefinitionFhirVersionKind["_050"] = "0.5.0";
    StructureDefinitionFhirVersionKind["_100"] = "1.0.0";
    StructureDefinitionFhirVersionKind["_101"] = "1.0.1";
    StructureDefinitionFhirVersionKind["_102"] = "1.0.2";
    StructureDefinitionFhirVersionKind["_110"] = "1.1.0";
    StructureDefinitionFhirVersionKind["_140"] = "1.4.0";
    StructureDefinitionFhirVersionKind["_160"] = "1.6.0";
    StructureDefinitionFhirVersionKind["_180"] = "1.8.0";
    StructureDefinitionFhirVersionKind["_300"] = "3.0.0";
    StructureDefinitionFhirVersionKind["_301"] = "3.0.1";
    StructureDefinitionFhirVersionKind["_330"] = "3.3.0";
    StructureDefinitionFhirVersionKind["_350"] = "3.5.0";
    StructureDefinitionFhirVersionKind["_400"] = "4.0.0";
})(StructureDefinitionFhirVersionKind = exports.StructureDefinitionFhirVersionKind || (exports.StructureDefinitionFhirVersionKind = {}));
var StructureDefinitionKindKind;
(function (StructureDefinitionKindKind) {
    StructureDefinitionKindKind["_primitiveType"] = "primitive-type";
    StructureDefinitionKindKind["_complexType"] = "complex-type";
    StructureDefinitionKindKind["_resource"] = "resource";
    StructureDefinitionKindKind["_logical"] = "logical";
})(StructureDefinitionKindKind = exports.StructureDefinitionKindKind || (exports.StructureDefinitionKindKind = {}));
var StructureDefinitionDerivationKind;
(function (StructureDefinitionDerivationKind) {
    StructureDefinitionDerivationKind["_specialization"] = "specialization";
    StructureDefinitionDerivationKind["_constraint"] = "constraint";
})(StructureDefinitionDerivationKind = exports.StructureDefinitionDerivationKind || (exports.StructureDefinitionDerivationKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_StructureDefinition = t.recursion('IStructureDefinition', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('StructureDefinition')
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            url: RTTI_uri_1.RTTI_uri,
            _url: RTTI_Element_1.RTTI_Element,
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            version: t.string,
            _version: RTTI_Element_1.RTTI_Element,
            name: t.string,
            _name: RTTI_Element_1.RTTI_Element,
            title: t.string,
            _title: RTTI_Element_1.RTTI_Element,
            status: (0, EnumType_1.createEnumType)(StructureDefinitionStatusKind, 'StructureDefinitionStatusKind'),
            _status: RTTI_Element_1.RTTI_Element,
            experimental: t.boolean,
            _experimental: RTTI_Element_1.RTTI_Element,
            date: RTTI_dateTime_1.RTTI_dateTime,
            _date: RTTI_Element_1.RTTI_Element,
            publisher: t.string,
            _publisher: RTTI_Element_1.RTTI_Element,
            contact: t.array(RTTI_ContactDetail_1.RTTI_ContactDetail),
            description: RTTI_markdown_1.RTTI_markdown,
            _description: RTTI_Element_1.RTTI_Element,
            useContext: t.array(RTTI_UsageContext_1.RTTI_UsageContext),
            jurisdiction: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            purpose: RTTI_markdown_1.RTTI_markdown,
            _purpose: RTTI_Element_1.RTTI_Element,
            copyright: RTTI_markdown_1.RTTI_markdown,
            _copyright: RTTI_Element_1.RTTI_Element,
            keyword: t.array(RTTI_Coding_1.RTTI_Coding),
            fhirVersion: (0, EnumType_1.createEnumType)(StructureDefinitionFhirVersionKind, 'StructureDefinitionFhirVersionKind'),
            _fhirVersion: RTTI_Element_1.RTTI_Element,
            mapping: t.array(RTTI_StructureDefinition_Mapping_1.RTTI_StructureDefinition_Mapping),
            kind: (0, EnumType_1.createEnumType)(StructureDefinitionKindKind, 'StructureDefinitionKindKind'),
            _kind: RTTI_Element_1.RTTI_Element,
            abstract: t.boolean,
            _abstract: RTTI_Element_1.RTTI_Element,
            context: t.array(RTTI_StructureDefinition_Context_1.RTTI_StructureDefinition_Context),
            contextInvariant: t.array(t.string),
            _contextInvariant: t.array(RTTI_Element_1.RTTI_Element),
            type: RTTI_uri_1.RTTI_uri,
            _type: RTTI_Element_1.RTTI_Element,
            baseDefinition: RTTI_canonical_1.RTTI_canonical,
            derivation: (0, EnumType_1.createEnumType)(StructureDefinitionDerivationKind, 'StructureDefinitionDerivationKind'),
            _derivation: RTTI_Element_1.RTTI_Element,
            snapshot: RTTI_StructureDefinition_Snapshot_1.RTTI_StructureDefinition_Snapshot,
            differential: RTTI_StructureDefinition_Differential_1.RTTI_StructureDefinition_Differential
        })
    ]);
});
//# sourceMappingURL=RTTI_StructureDefinition.js.map